// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterLinks__link":"ce_a bht_h bht_kh bht_we bht_su bht_vt bht_sw bht_sn"};